import { useState, type FormEvent } from 'react';
import { CONTEXT_HEADINGS, type ContextHeading } from '@jabberr/core';

export interface PinFormProps {
  /** Prefilled text: the user's selection, or the turn's first sentence. */
  initialText: string;
  busy?: boolean;
  onPin: (pin: { heading: ContextHeading; text: string }) => void;
  onCancel: () => void;
}

/** One bullet under one skeleton heading of the project context. */
export function PinForm({ initialText, busy, onPin, onCancel }: PinFormProps) {
  const [heading, setHeading] = useState<ContextHeading>('Memory');
  const [text, setText] = useState(initialText);
  const submit = (e: FormEvent): void => {
    e.preventDefault();
    const line = text.replace(/\s+/g, ' ').trim();
    if (line.length === 0) return;
    onPin({ heading, text: line.slice(0, 500) });
  };
  return (
    <form className="pin-form" onSubmit={submit}>
      <label className="row small">
        Under
        <select value={heading} onChange={(e) => setHeading(e.target.value as ContextHeading)} aria-label="Context heading">
          {CONTEXT_HEADINGS.map((h) => (
            <option key={h} value={h}>
              {h}
            </option>
          ))}
        </select>
      </label>
      <input value={text} onChange={(e) => setText(e.target.value)} maxLength={500} aria-label="Pinned text" autoFocus />
      <div className="row">
        <button type="submit" className="btn btn-primary btn-small" disabled={busy || text.trim().length === 0}>
          Add
        </button>
        <button type="button" className="link-btn small" onClick={onCancel} disabled={busy}>
          Cancel
        </button>
      </div>
    </form>
  );
}
